import { useState } from "react";
import { Link } from "wouter";
import { ArrowRight } from "lucide-react";
import screenCars from "@/content/apex-screen-cars.json";
import "./apex-screen-car.css";

export interface ApexScreenCarData {
  name: string; path: string; location: string; image: string; small: string; verifiedAt: string; available: boolean;
}

const CARS = screenCars as Record<string, ApexScreenCarData | null | undefined>;
const BASE = (import.meta.env.BASE_URL || "/").replace(/\/$/, "");
const SAFE_PATH = /^\/(car|uk\/cars)\/[a-z0-9-]+$/;

export function getApexScreenCar(title: string): ApexScreenCarData | null {
  const c = CARS[title];
  return c && c.available && SAFE_PATH.test(c.path) ? c : null;
}

function Fallback({ index }: { index: number }) {
  return <div className="sc-card sc-fallback" data-testid={`card-screen-car-fallback-${index}`}>
    <p className="sc-label">Explore a related car</p>
    <Link href={`~${BASE}/search`} className="sc-cta" data-testid={`link-screen-car-browse-${index}`}>
      Browse cars <ArrowRight className="h-4 w-4" aria-hidden />
    </Link>
  </div>;
}

export function ApexScreenCar({ title, index, car }: { title: string; index: number; car?: ApexScreenCarData | null }) {
  const c = car === undefined ? getApexScreenCar(title) : car;
  const [failed, setFailed] = useState(false);
  if (!c || !c.available || !SAFE_PATH.test(c.path) || failed) return <Fallback index={index} />;
  return <Link href={`~${BASE}${c.path}`} className="sc-card" data-testid={`link-screen-car-${index}`}
    aria-label={`View car profile: ${c.name}, ${c.location}. Same model family, not the screen-used vehicle.`}>
    <span className="sc-photo">
      <img src={c.small} srcSet={`${c.small} 400w, ${c.image} 800w`} sizes="160px" width={160} height={120}
        alt="" loading="lazy" decoding="async" onError={() => setFailed(true)} />
    </span>
    <span className="sc-body">
      <span className="sc-label">Explore a related car</span>
      <span className="sc-name">{c.name}</span>
      <span className="sc-loc">{c.location}</span>
      <span className="sc-note">Same model family · not the screen-used vehicle</span>
      <span className="sc-cta">View car profile <ArrowRight className="sc-arrow h-4 w-4" aria-hidden /></span>
    </span>
  </Link>;
}
